import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    text-align: left;
    padding: 0.65rem 0.57rem 0.65rem 0.78rem;
    color: ${({ theme }) => theme.colors.textLight};
    background: ${({ theme }) => theme.colors.action};
    line-height: 1.42rem;
    white-space: nowrap;
  }

  th:first-of-type {
    padding-left: 2.42rem;
  }

  th:last-child {
    padding-right: 7.14rem;
  }
`;

export const TableRow = styled.tr`
  td {
    padding: 0.71rem 0 0.21rem;

    div {
      height: 1.71rem;
      padding-left: 0.78rem;
      border-bottom: 1px dashed black;
      white-space: nowrap;
    }
  }

  td:first-of-type {
    padding-left: 1.42rem;

    div {
      padding-left: 1rem;
    }
  }

  td:last-child {
    padding-right: 1.42rem;
  }
`;

export const TableRowFull = styled.tr`
  td {
    padding: 0.35rem 1.78rem 1.42rem 2.42rem;
  }
`;

export const TableLink = styled(Link)`
  text-decoration: none;
`;

export const NoResultMessage = styled.div`
  text-align: center;
  margin: 1rem 0;

  span {
    color: ${({ theme }) => theme.colors.action};
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
  }
`;
